export const CREATE_JOURNAL_VOUCHER  = 'CREATE_JOURNAL_VOUCHER';
export const GET_JOURNAL_VOUCHER  = 'GET_JOURNAL_VOUCHER';
export const GET_JOURNAL_VOUCHER_PAGE  = 'GET_JOURNAL_VOUCHER_PAGE';
export const JOURNAL_VOUCHER_REQUEST  = 'JOURNAL_VOUCHER_REQUEST';
export const DELETE_JOURNAL_VOUCHER  = 'DELETE_JOURNAL_VOUCHER';
export const UPDATE_JOURNAL_VOUCHER  = 'UPDATE_JOURNAL_VOUCHER';
export const JOURNAL_VOUCHER_REQUEST_SUCCESS  = 'JOURNAL_VOUCHER_REQUEST_SUCCESS';
export const JOURNAL_VOUCHER_REQUEST_FAILURE  = 'JOURNAL_VOUCHER_REQUEST_FAILURE';